export default __webpack_public_path__ + "static/cafe_36061-ab1c6423e346aeb22d97be09ad137835.png";